function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { useEffect, useState, useRef, useContext } from 'react';
import { Input, Space } from 'antd';
import classnames from 'classnames';
import moment from 'dayjs';
import { staticFormatMessage } from "../locale";
import { LocaleContext } from "../locale";
import "./style/input-date";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var dateFormat = 'DD / MM / YYYY';
// momentjs format中能出现的合法字符
var momentLetterArr = ['A', 'a', 'd', 'D', 'H', 'h', 'm', 'M', 'Q', 's', 'w', 'X', 'Y', ' '];

// 对于每一个input的输入做一个简单的时间限制
var sampleLimit = {
  M: 12,
  D: 31,
  H: 23,
  h: 12,
  m: 59,
  s: 59
};
function dealFormat(str) {
  var delimiter = '';
  for (var i = 0; i < str.length; i++) {
    var current = str[i];
    if (!momentLetterArr.includes(current)) {
      delimiter = current;
      break;
    }
  }
  return [str.split(delimiter), delimiter];
}
var getTextWidth = function getTextWidth(str) {
  if (typeof document === 'undefined') {
    return str.length * 16;
  }
  var ele = document.createElement('span');
  ele.style.fontSize = '16px';
  ele.style.opacity = '0';
  ele.innerText = str;
  document.body.appendChild(ele);
  var width = ele.offsetWidth;
  document.body.removeChild(ele);
  return width + 1;
};
var IglooInputDate = function IglooInputDate(props) {
  // format除去空格
  var _props$format = props.format,
    format = _props$format === void 0 ? dateFormat : _props$format,
    onChangeProps = props.onChange,
    setFieldError = props.setFieldError,
    disabled = props.disabled,
    value = props.value;

  // 用来做 输入跳转
  var firstInput = useRef(null);
  var secondInput = useRef(null);
  var thirdInput = useRef(null);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    used = _useState2[0],
    setUsed = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    active = _useState4[0],
    setActive = _useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    inputValue = _useState6[0],
    setInput = _useState6[1];
  var _useContext = useContext(LocaleContext),
    formatMessage = _useContext.formatMessage;
  var formatDeleteSpace = format.replace(/\s+/g, '');
  var _dealFormat = dealFormat(formatDeleteSpace),
    _dealFormat2 = _slicedToArray(_dealFormat, 2),
    timeInputArr = _dealFormat2[0],
    delimiter = _dealFormat2[1];
  useEffect(function () {
    if (!value) {
      setInput(Array(timeInputArr.length));
    } else {
      setUsed(true);
    }
  }, []);
  useEffect(function () {
    if (!value || value === 'error type') return;
    var init = value.split(delimiter);
    setInput(init);
  }, [value]);
  useEffect(function () {
    if (!used) return;
    if (!inputValue.length) return;
    var currentInput = inputValue.join(delimiter);
    var available = moment(currentInput.replace(/\s+/g, ''), formatDeleteSpace, true).isValid();
    var value = moment(currentInput, formatDeleteSpace).format(format);
    if (available) {
      onChangeProps && onChangeProps(value);
    } else {
      onChangeProps && onChangeProps('error type');
      setFieldError && setFieldError(formatMessage({
        id: 'Please enter a valid date.'
      }));
    }
  }, [inputValue]);
  var autoZero = function autoZero(str, refArr, index, inputFormat //format模版
  ) {
    var valueInput = str.replace(/[^0-9]/gi, '');
    var firstWord = inputFormat[0];
    if (valueInput !== '' &&
    // 有输入过东西
    valueInput.length < inputFormat.length && firstWord !== 'Y') {
      //针对M和D
      valueInput = '0' + valueInput;
      handleOnChange(valueInput, refArr, index, inputFormat);
    }
  };
  var handleOnChange = function handleOnChange(str, currentInput, index, inputFormat //format模版
  ) {
    var copyInput = _toConsumableArray(currentInput);
    var valueInput = str.replace(/[^0-9]/gi, '');
    var firstWord = inputFormat[0];
    if (valueInput.length === inputFormat.length) {
      var timeLimit = sampleLimit[firstWord];
      // 关于 单个input的限制还是要有的
      if (timeLimit) {
        if (timeLimit < Number(valueInput)) {
          setFieldError && setFieldError(formatMessage({
            id: 'Please enter a valid date.'
          }));
        } else {
          setFieldError && setFieldError('');
        }
      }
      switch (index) {
        case 0:
          if (secondInput.current) secondInput.current.focus();
          break;
        case 1:
          if (thirdInput.current) thirdInput.current.focus();
          break;
      }
    }
    copyInput.splice(index, 1, valueInput.slice(0, inputFormat.length));
    setInput(_toConsumableArray(copyInput));
    setUsed(true);
  };
  return /*#__PURE__*/_jsx("div", {
    className: classnames('igloo-input-date', {
      'igloo-input-date-disable': disabled
    }, "".concat(active ? 'igloo-input-date-focus' : '')),
    onFocus: function onFocus() {
      return setActive(true);
    },
    onBlur: function onBlur() {
      return setActive(false);
    },
    children: /*#__PURE__*/_jsx(Space, {
      style: {
        cursor: 'default'
      },
      size: 12,
      children: timeInputArr.map(function (item, index) {
        var islast = index === timeInputArr.length - 1;
        var ref = null;
        switch (index) {
          case 0:
            ref = firstInput;
            break;
          case 1:
            ref = secondInput;
            break;
          case 2:
            ref = thirdInput;
            break;
        }
        var width = getTextWidth(item);
        return islast ? /*#__PURE__*/_jsx(Input, {
          className: "igloo-input-date-input",
          placeholder: item,
          ref: ref,
          value: (inputValue[index] || '').replace(/\s+/g, ''),
          onBlur: function onBlur(e) {
            return autoZero(e.target.value, inputValue, index, item);
          },
          onChange: function onChange(e) {
            return handleOnChange(e.target.value, inputValue, index, item);
          },
          bordered: false,
          maxLength: item.length,
          style: {
            width: width
          },
          disabled: disabled,
          type: "number"
        }, item) : /*#__PURE__*/_jsxs(Space, {
          style: {
            cursor: 'default'
          },
          size: 12,
          children: [/*#__PURE__*/_jsx(Input, {
            className: "igloo-input-date-input",
            placeholder: item,
            ref: ref,
            bordered: false,
            maxLength: item.length,
            value: (inputValue[index] || '').replace(/\s+/g, ''),
            onBlur: function onBlur(e) {
              return autoZero(e.target.value, inputValue, index, item);
            },
            onChange: function onChange(e) {
              return handleOnChange(e.target.value, inputValue, index, item);
            },
            style: {
              width: width
            },
            disabled: disabled,
            type: "number"
          }, item), /*#__PURE__*/_jsx("span", {
            className: "igloo-input-date-input-delimiter",
            children: delimiter
          })]
        }, item);
      })
    })
  });
};
function checkTime(value, format) {
  if (!value) {
    return Promise.resolve();
  }
  if (value === 'error type') {
    return Promise.reject(staticFormatMessage({
      id: 'Please enter a valid date.'
    }));
  }
  return moment(value, format, true).isValid() ? Promise.resolve() : Promise.reject(staticFormatMessage({
    id: 'Please enter a valid date.'
  }));
}
IglooInputDate.formItemPropsHandler = function (config) {
  var _config$format = config.format,
    format = _config$format === void 0 ? dateFormat : _config$format;
  return {
    rules: [{
      validator: function validator(_, value) {
        return checkTime(value, format);
      }
    }]
  };
};
export default IglooInputDate;